import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Zap, Infinity, Star, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-8 pb-8 md:pt-10 md:pb-12 px-4 overflow-hidden flex flex-col items-center text-center" data-id="element-129">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-130" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-131">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-dark-lighter border border-gold/30 text-gold-light text-xs font-semibold tracking-wider mb-3" data-id="element-132">
          <span data-id="element-133">🔺</span> DESCUBRÍ LOS SECRETOS DE UNA DE LAS CIVILIZACIONES MÁS
          FASCINANTES DE LA HISTORIA <span data-id="element-134">🔺</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading leading-tight mb-4 text-white" data-id="element-135">
          Egipto <span className="text-gold-light" data-id="element-136">Legendario</span>
        </h1>

        <p className="text-base md:text-lg text-gray-300 mb-4 max-w-2xl mx-auto" data-id="element-137">
          Más de 6 tomos y 3 bonos exclusivos para explorar el mundo de los
          faraones, las pirámides, los dioses y los misterios que aún siguen
          sorprendiendo a la humanidad.
        </p>

        <motion.img src="https://cdn.magicpatterns.com/uploads/5ayyEmqaWfH1B61K7RVJon/ChatGPT_Image_8_jul_2026,_13_31_32_-_Editado.png" alt="Colección Egipto Legendario — 6 tomos y 3 bonos exclusivos sobre el Antiguo Egipto" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="w-full max-w-lg md:max-w-xl mx-auto mb-5 drop-shadow-[0_0_50px_rgba(212,168,67,0.25)]" data-id="element-138" />

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mb-6 text-xs md:text-sm text-gray-300 font-medium" data-id="element-139">
          <div className="flex items-center gap-1.5" data-id="element-140">
            <BookOpen className="w-4 h-4 text-gold" data-id="element-141" />
            <span data-id="element-142">6 tomos completos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-143">
            <Gift className="w-4 h-4 text-gold" data-id="element-144" />
            <span data-id="element-145">3 bonos exclusivos</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-146">
            <Star className="w-4 h-4 text-gold" data-id="element-147" />
            <span data-id="element-148">100% Digital</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-149">
            <Zap className="w-4 h-4 text-gold" data-id="element-150" />
            <span data-id="element-151">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-152">
            <Infinity className="w-4 h-4 text-gold" data-id="element-153" />
            <span data-id="element-154">Acceso de por vida</span>
          </div>
        </div>

        <motion.a href="#oferta-premium" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold to-gold-light text-dark font-bold text-base md:text-lg rounded-lg shadow-[0_0_30px_rgba(212,168,67,0.3)] hover:shadow-[0_0_40px_rgba(212,168,67,0.5)] transition-all animate-pulse-slow mb-4" data-id="element-155">
          👉 QUIERO DESCUBRIR EGIPTO
        </motion.a>

        <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-xs text-gray-400" data-id="element-156">
          <div className="flex items-center gap-1.5" data-id="element-157">
            <Shield className="w-3.5 h-3.5" data-id="element-158" />
            <span data-id="element-159">Garantía 7 días</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-160">|</span>
          <div className="flex items-center gap-1.5" data-id="element-161">
            <Lock className="w-3.5 h-3.5" data-id="element-162" />
            <span data-id="element-163">Pago seguro</span>
          </div>
          <span className="hidden sm:inline text-dark-border" data-id="element-164">|</span>
          <div className="flex items-center gap-1.5" data-id="element-165">
            <CreditCard className="w-3.5 h-3.5" data-id="element-166" />
            <span data-id="element-167">Acceso de por vida</span>
          </div>
        </div>
      </motion.div>
    </section>;
}